import { Pipe, PipeTransform } from '@angular/core';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';

@Pipe({
  standalone: true,
  name: 'stockQuantityFormatPipe'
})
export class StockQuantityFormatPipe implements PipeTransform {
  constructor(private companyConfig: ConfigurationService) { }

  transform(value: number, fractional: boolean): string {
    if (fractional)
      return this.companyConfig.formatNumberDecimalByCountry(value);

    return this.companyConfig.formatNumberIntegerByCountry(value);
  }
}